import { environment } from 'src/environment';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import * as uikit from 'uikit'
@Component({
  selector: 'app-change-name',
  templateUrl: './change-name.component.html',
  styleUrls: ['./change-name.component.scss', '../modal-screens.scss']
})
export class ChangeNameComponent implements OnInit {


  changeNameForm: any;
  skinName = environment.skinName;
  constructor(public configService: ConfigurationService, private formBuilder: FormBuilder) { 
    uikit.util.on(document, 'beforehide', '#change-name', ()=>{
      this.changeNameForm.reset();
    });
  }

  ngOnInit(): void {
    this.changeNameForm = this.formBuilder.group({
      name: [''],
      surname: ['']
    });
  }


  changeName(){
    // console.log(this.changeNameForm.get('name').value);
    // console.log(this.changeNameForm.get('surname').value)
  }

}
